<template>
    <div>
        <!-- Home Slider  -->
      <div class="container">
        <div class="row">
          <div class="col-md-12  mobile-hide">
            <carousel :autoplay="true" :nav="false" :autoWidth="true" :autoHeight="true">
              <router-link to="/register">
                <img v-if="lang === 'ar'" src="/static/images/banner/arabic.jpg" style="width: 1110px;" alt="slide1">
              <img v-else src="/static/images/banner/english.jpg" style="width: 1110px;" alt="slide1">
              </router-link>
            </carousel>
          </div>
          <div class="col-md-12 mobilex">
            <router-link to="/register">
              <img v-if="lang === 'ar'" src="/static/images/banner/arabicM.jpg" alt="slide1" width="380">
              <img v-else src="/static/images/banner/englishM.jpg" alt="slide1" width="380">
            </router-link>
          </div>


          <div v-if="countryMain === 1" class="col-md-12">
            <img class="mobile-hide" src="/static/homepage.jpg" alt="slide1" width="1110">
            <img class="mobilex" src="/static/homepage.jpg" alt="slide1" width="380">
          </div>

          <div v-if="countryMain === 19" class="col-md-12">
            <img class="mobile-hide" src="/static/homepage19.jpg" alt="slide1" width="1110">
            <img class="mobilex" src="/static/homepage19.jpg" alt="slide1" width="380">
          </div>


        </div>
      </div>

<!--        <div class="home-slider">-->
<!--            <div class="container">-->
<!--                <div class="row">-->
<!--                    <div class="col-md-12">-->
<!--                        <div class="home-slides owl-carousel owl-theme" id="home-slider">-->
<!--                            &lt;!&ndash; Item .1 &ndash;&gt;-->
<!--                            <a v-if="lang === 'ar'" href="/">-->
<!--                                <div class="home-slide" style="background-image: linear-gradient(to right top, #ffffff, #fbfbfb, #f6f6f6, #f2f2f2, #eeeeee); ">-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-6 col-12">-->
<!--                                            <div class="slide-content">-->
<!--                                                <img src="/static/images/slide-asset.png">-->
<!--                                                <h5>موقع التسوق قريبا</h5>-->
<!--                                                <h4>تسجيل بطاقة الخصم</h4>-->
<!--                                                <h5>خصومات ممتازة</h5>-->
<!--                                                <div class="discount">تسجيل</div>-->
<!--                                                <h5>سجل بطاقة وافر</h5>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-6 col-12">-->
<!--                                            <div class="slide-img">-->
<!--                                                <img src="/static/images/slide1.png" alt="slide">-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->

<!--&lt;!&ndash;                          <a v-if="lang === 'ar'" href="/">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="home-slide" style="background-image: linear-gradient(to right top, #ffffff, #fbfbfb, #f6f6f6, #f2f2f2, #eeeeee); ">&ndash;&gt;-->
<!--&lt;!&ndash;                              <div class="row">&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="col-md-6 col-12">&ndash;&gt;-->
<!--&lt;!&ndash;                                  <div class="slide-content">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <img src="/static/images/slide-asset.png">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <h5>غذائية</h5>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <h4>خصم محدود الوقت</h4>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <h5>وفر حتى</h5>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="discount">45%</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <h5>دخول المتجر</h5>&ndash;&gt;-->
<!--&lt;!&ndash;                                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="col-md-6 col-12">&ndash;&gt;-->
<!--&lt;!&ndash;                                  <div class="slide-img">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <img src="/static/images/slide1.png" alt="slide">&ndash;&gt;-->
<!--&lt;!&ndash;                                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                              </div>&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          </a>&ndash;&gt;-->
<!--                            &lt;!&ndash; item.2 &ndash;&gt;-->
<!--                            <a v-else href="/">-->
<!--                                <div class="home-slide" style="background-image: linear-gradient(to right top, #ffffff, #fbfbfb, #f6f6f6, #f2f2f2, #eeeeee); ">-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-6 col-12">-->
<!--                                            <div class="slide-content">-->
<!--                                                <img src="/static/images/slide-asset.png">-->
<!--                                                <h5>WEBSITE COMING SOON</h5>-->
<!--                                                <h4>REGISTER YOUR WAFFIR CARD</h4>-->
<!--                                                <h5>SAVE ON PURCHASES</h5>-->
<!--                                                <div class="discount">START</div>-->
<!--                                                <h5>REGISTER CARD</h5>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-6 col-12">-->
<!--                                            <div class="slide-img">-->
<!--                                                <img src="/static/images/slide1.png" alt="slide">-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

        <!-- Top Categoraies Section -->
<!--        <section class="top-cat">-->
<!--            <div class="container">-->
<!--                <div class="row">-->
<!--                    <div class="col-md-12">-->
<!--                        <h1 v-if="lang === 'ar'" style="">الفئات الخاصة</h1>-->
<!--                        <h1 v-else>Top Categories</h1>-->
<!--                        <p v-if="lang === 'ar'"><span>نقدم لك أفضل الخصومات على الإطلاق</span></p>-->
<!--                        <p v-else>SERVING YOU THE BEST DISCOUNTS EVER</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="row">-->
<!--                    <div class="col-md-12">-->
<!--                        <div class="cat-slider owl-carousel owl-theme" id="cat-slider">-->
<!--&lt;!&ndash;                            <a href="/">&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="cat-slide">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <img src="/static/images/cat/bread.png" alt="cateName">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span>Bread</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                            </a>&ndash;&gt;-->
<!--                            <a href="http://www.universalcsc.com/UniversalProducts.aspx?Category=4">-->
<!--                                <div class="cat-slide">-->
<!--                                    <img src="/static/images/cat/dry.jpg" alt="cateName">-->
<!--                                    <span v-if="lang === 'ar'">الطعام الجاف</span>-->
<!--                                    <span v-else>Dry Food</span>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                            <a href="http://www.universalcsc.com/LocalProducts.aspx?Category=22">-->
<!--                                <div class="cat-slide">-->
<!--                                    <img src="/static/images/cat/frozen.jpg" alt="cateName">-->
<!--                                    <span v-if="lang === 'ar'">المجمدات</span>-->
<!--                                    <span v-else>Frozen</span>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                            <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=6">-->
<!--                                <div class="cat-slide">-->
<!--                                    <img src="/static/images/cat/home.jpg" alt="cateName">-->
<!--                                    <span v-if="lang === 'ar'">عناية المنزل</span>-->
<!--                                    <span v-else>Appliances</span>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                            <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=17">-->
<!--                                <div class="cat-slide">-->
<!--                                    <img src="/static/images/cat/meat.jpg" alt="cateName">-->
<!--                                    <span v-if="lang === 'ar'">لحم و دواجن</span>-->
<!--                                    <span v-else>Meat</span>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                            <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=14">-->
<!--                                <div class="cat-slide">-->
<!--                                    <img src="/static/images/cat/dairy.jpg" alt="cateName">-->
<!--                                    <span v-if="lang === 'ar'">منتجات الألبان</span>-->
<!--                                    <span v-else>Dairy</span>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="row banners">-->
<!--                    <div class="col-md-6">-->
<!--                        <div class="banner" style="background-image: url(/static/images/green.png)">-->
<!--                          <br/><br/>-->
<!--                            <h4 style="color:green">-->
<!--                                <span v-if="lang === 'ar'">خضروات</span>-->
<!--                                <span v-else>Vegetable</span>-->
<!--                            </h4>-->
<!--                            <h2 v-if="lang === 'ar'">عالم أخضر</h2>-->
<!--                            <h2 v-else>Green World</h2>-->
<!--                            <h5 v-if="lang === 'ar'">احصل على خصم 40٪ على العناصر المختارة.</h5>-->
<!--                            <h5 v-else>Get 15% Off on selected items.</h5>-->
<!--&lt;!&ndash;                            <a v-if="lang === 'ar'" class="btn-green" href="/">أعرف أكثر <i class="fas fa-caret-left"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                            <a v-else class="btn-green" href="/">learn more <i class="fas fa-caret-right"></i></a>&ndash;&gt;-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-6">-->
<!--                        <div class="banner" style="background-image: url(/static/images/red.png)">-->
<!--                          <br/><br/>-->
<!--                            <h4 v-if="lang === 'ar'" style="color:#ff3e46">فواكه طازجة</h4>-->
<!--                            <h4 v-else style="color:#ff3e46">Fresh Fruits</h4>-->
<!--                            <h2 v-if="lang === 'ar'">الطعام الصحي</h2>-->
<!--                            <h2 v-else>Healthy Food</h2>-->
<!--                            <h5 v-if="lang === 'ar'">احصل على 60٪ خصم على العناصر المختارة.</h5>-->
<!--                            <h5 v-else>Get 25% Off on selected items.</h5>-->
<!--&lt;!&ndash;                            <a v-if="lang === 'ar'" class="btn-red" href="/"> أعرف أكثر <i class="fas fa-caret-left"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                            <a v-else class="btn-red" href="/">learn more <i class="fas fa-caret-right"></i></a>&ndash;&gt;-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </section>-->

        <!-- Best Sellers -->
<!--        <section class="best-sellers">-->
<!--            <div class="container">-->
<!--                <div class="row">-->
<!--                    <div class="col-md-12">-->
<!--                        <h1 v-if="lang === 'ar'" class="title">الأكثر مبيعا</h1>-->
<!--                        <h1 v-else class="title">Best Sellers</h1>-->
<!--                        <p v-if="lang === 'ar'"><span>أسعار لن تجدها في أي مكان آخر</span></p>-->
<!--                        <p v-else>PRICES YOU WILL FIND NOWHERE ELSE</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="row">-->
<!--                    <div class="best-slider owl-carousel owl-theme">-->
<!--                        &lt;!&ndash; Item .1 &ndash;&gt;-->
<!--                        <div class="best-slide">-->
<!--                            <div class="item-top">-->
<!--                                <span v-if="lang === 'ar'" class="hot">أعلى</span>-->
<!--&lt;!&ndash;                                <span v-else class="hot">Hot</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="discount">-40%</span>&ndash;&gt;-->
<!--                                <img src="/static/images/fr1.png" alt="item">-->
<!--                            </div>-->
<!--                            <h1 v-if="lang === 'ar'">عنب أحمر بدون بذور طازج</h1>-->
<!--                            <h1 v-else>Fresh Red Seedless</h1>-->
<!--                            <span class="stars-active" style="width:88%">-->
<!--                              <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>-->
<!--                            </span>-->
<!--                            <a v-if="lang === 'ar'" href="/"><i class="fas fa-shopping-cart"></i> أضف إلى السلة </a>-->
<!--&lt;!&ndash;                            <a v-else href="/"><i class="fas fa-shopping-cart"></i> add to cart</a>&ndash;&gt;-->
<!--                        </div>-->
<!--                        &lt;!&ndash; Item .2 &ndash;&gt;-->
<!--                      <div class="best-slide">-->
<!--                        <div class="item-top">-->
<!--                          <span v-if="lang === 'ar'" class="hot">أعلى</span>-->
<!--&lt;!&ndash;                          <span v-else class="hot">Hot</span>&ndash;&gt;-->
<!--&lt;!&ndash;                          <span class="discount">-34%</span>&ndash;&gt;-->
<!--                          <img src="/static/images/featured/tomato.JPG" alt="item">-->
<!--                        </div>-->
<!--                        <h1 v-if="lang === 'ar'">طماطم طازجة</h1>-->
<!--                        <h1 v-else>Fresh Tomatoes</h1>-->
<!--                        <span class="stars-active" style="width:88%"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i></span>-->
<!--                        <a v-if="lang === 'ar'" href="/"><i class="fas fa-shopping-cart"></i> أضف إلى السلة </a>-->
<!--&lt;!&ndash;                        <a v-else href="/"><i class="fas fa-shopping-cart"></i> add to cart</a>&ndash;&gt;-->
<!--                      </div>-->
<!--                        &lt;!&ndash; Item .3 &ndash;&gt;-->
<!--                      <div class="best-slide">-->
<!--                        <div class="item-top">-->
<!--                          <span v-if="lang === 'ar'" class="hot">أعلى</span>-->
<!--&lt;!&ndash;                          <span v-else class="hot">Hot</span>&ndash;&gt;-->
<!--&lt;!&ndash;                          <span class="discount">-40%</span>&ndash;&gt;-->
<!--                          <img src="/static/images/featured/cabbage.JPG" alt="item">-->
<!--                        </div>-->
<!--                        <h1 v-if="lang === 'ar'">الملفوف العضوي الطازج</h1>-->
<!--                        <h1 v-else>Fresh Organic Cabbage</h1>-->
<!--                        <span class="stars-active" style="width:88%"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i></span>-->
<!--                        <a v-if="lang === 'ar'" href="/"><i class="fas fa-shopping-cart"></i> أضف إلى السلة </a>-->
<!--&lt;!&ndash;                        <a v-else href="/"><i class="fas fa-shopping-cart"></i> add to cart</a>&ndash;&gt;-->
<!--                      </div>-->
<!--                        &lt;!&ndash; Item .4 &ndash;&gt;-->
<!--                      <div class="best-slide">-->
<!--                        <div class="item-top">-->
<!--                          <span v-if="lang === 'ar'" class="hot">أعلى</span>-->
<!--&lt;!&ndash;                          <span v-else class="hot">Hot</span>&ndash;&gt;-->
<!--&lt;!&ndash;                          <span class="discount">60%</span>&ndash;&gt;-->
<!--                          <img src="/static/images/featured/corn.jpg" alt="item">-->
<!--                        </div>-->
<!--                        <h1 v-if="lang === 'ar'">الذرة الطازجة</h1>-->
<!--                        <h1 v-else>Fresh Sweet Corn</h1>-->
<!--                        <span class="stars-active" style="width:88%"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i></span>-->
<!--                        <a v-if="lang === 'ar'" href="/"><i class="fas fa-shopping-cart"></i> أضف إلى السلة </a>-->
<!--&lt;!&ndash;                        <a v-else href="/"><i class="fas fa-shopping-cart"></i> add to cart</a>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="row deals">-->
<!--                    <div v-if="lang === 'ar'" class="col-md-6">-->
<!--                        <div class="best-deal" style="background-image: url(/static/images/fruites.png)">-->
<!--                            <div class="content">-->
<!--                              <br/><br/><br/>-->
<!--                              <h4>ثمار</h4>-->
<!--                                <h1>طازجة</h1>-->
<!--&lt;!&ndash;                                <p class="discount">-16%</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                <a href="/">تسوق الآن</a>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-if="lang === 'ar'" class="col-md-6">-->
<!--                        <div class="best-deal" style="background-image: url(/static/images/spices.png)">-->
<!--                            <div class="content">-->
<!--                              <br/><br/><br/>-->
<!--                              <h4>توابل</h4>-->
<!--                                <h1>هندية</h1>-->
<!--&lt;!&ndash;                                <p class="discount">20%</p>&ndash;&gt;-->
<!--&lt;!&ndash;                                <a href="/">تسوق الآن</a>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                  <div v-if="lang !== 'ar'" class="col-md-6">-->
<!--                    <div class="best-deal" style="background-image: url(/static/images/fruites.png)">-->
<!--                      <div class="content">-->
<!--                        <br/><br/><br/>-->
<!--                        <h4>Fresh</h4>-->
<!--                        <h1>Fruits</h1>-->
<!--&lt;!&ndash;                        <p class="discount">-16%</p>&ndash;&gt;-->
<!--&lt;!&ndash;                        <a href="/">Shop Now</a>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div v-if="lang !== 'ar'" class="col-md-6">-->
<!--                    <div class="best-deal" style="background-image: url(/static/images/spices.png)">-->
<!--                      <div class="content">-->
<!--                        <br/><br/><br/>-->
<!--                        <h4>Indian</h4>-->
<!--                        <h1>Spices</h1>-->
<!--&lt;!&ndash;                        <p class="discount">20%</p>&ndash;&gt;-->
<!--&lt;!&ndash;                        <a href="/">Shop Now</a>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </section>-->

        <!-- brands Section -->
<!--        <section class="brands">-->
<!--            <div class="container">-->
<!--                <div class="row">-->
<!--                    <div v-if="lang === 'ar'" class="col-md-12">-->
<!--                        <h1 class="title">علاماتنا التجارية</h1>-->
<!--                        <p><span>نحن أكثر من مجرد سوبر ماركت</span></p>-->
<!--                    </div>-->
<!--                  <div v-else class="col-md-12">-->
<!--                    <h1 class="title">Our Brands</h1>-->
<!--                    <p>We are much more than just a supermarket</p>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="row brands-logo">-->
<!--                    <div class="col-md-2 col-xsm-12 block">-->
<!--                        <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=29">-->
<!--                            <img src="/static/images/brands/alzook.jpg" alt="brand">-->
<!--                        </a>-->
<!--                    </div>-->
<!--                    <div class="col-md-2 col-xsm-12 block">-->
<!--                        <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=17">-->
<!--                          <img src="/static/images/brands/dana.jpg" alt="brand">-->
<!--                        </a>-->
<!--                    </div>-->
<!--                    <div class="col-md-2 col-xsm-12 block">-->
<!--                        <a href="http://www.universalcsc.com/PrimeProducts.aspx?Category=5">-->
<!--                          <img src="/static/images/brands/jana.jpg" alt="brand">-->
<!--                        </a>-->
<!--                    </div>-->
<!--                    <div class="col-md-2 col-xsm-12 block">-->
<!--                        <a href="http://www.universalcsc.com/PrimeProducts.aspx">-->
<!--                          <img src="/static/images/brands/prime.jpg" alt="brand">-->
<!--                        </a>-->
<!--                    </div>-->
<!--                    <div class="col-md-2 col-xsm-12 block">-->
<!--                        <a href="http://www.universalcsc.com/PrimeProducts.aspx">-->
<!--                          <img src="/static/images/brands/salama.jpg" alt="brand">-->
<!--                        </a>-->
<!--                    </div>-->
<!--                    <div class="col-md-2 col-xsm-12 block">-->
<!--                        <a href="http://www.universalcsc.com/UniversalProducts.aspx?Category=4">-->
<!--                          <img src="/static/images/brands/universal.jpg" alt="brand">-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </section>-->

        <!-- testimonial Section -->
<!--        <section class="testimonial">-->
<!--            <div class="container">-->
<!--                <div class="row">-->
<!--                    <div class="col">-->
<!--                        <div class="testimonial-slider owl-carousel owl-theme">-->
<!--                            <div class="testimonial-item">-->
<!--                                <div class="test-img">-->
<!--                                    <i class="fas fa-quote-left"></i>-->
<!--                                    <img src="/static/images/testimonial.jpg" alt="client">-->
<!--                                </div>-->

<!--                                <div v-if="lang === 'ar'" class="message">-->
<!--                                  <span>اسعار جميلة جدا! والتوصيل سريع, يعطيكم العافية.</span>-->
<!--                                </div>-->
<!--                              <div v-else class="message">-->
<!--                                Lowest prices, as compared to all other hyper markets. I am amazed with such a fast delivery and coordination. I will highly recommend your store to my people!-->
<!--                              </div>-->
<!--                                <span class="name">AdhamZ</span>-->
<!--                              <span class="feel" v-if="lang === 'ar'"><span>عميل سعيد</span></span>-->
<!--                              <span class="feel" v-else>Happy Customer</span>-->
<!--                            </div>-->
<!--                            <div class="testimonial-item">-->
<!--                                <div class="test-img">-->
<!--                                    <i class="fas fa-quote-left"></i>-->
<!--                                    <img src="/static/images/testimonial2.jpg" alt="client">-->
<!--                                </div>-->
<!--                              <div v-if="lang === 'ar'" class="message">-->
<!--                                <span>اسعار جميلة جدا! والتوصيل سريع, يعطيكم العافية</span>-->
<!--                              </div>-->
<!--                              <div v-else class="message">-->
<!--                                Lowest prices, as compared to all other hyper markets. I am amazed with such a fast delivery and coordination. I will highly recommend your store to my people!-->
<!--                              </div>-->
<!--                              <span class="name">AdhamZ</span>-->
<!--                              <span class="feel" v-if="lang === 'ar'"><span>عميل سعيد</span></span>-->
<!--                              <span class="feel" v-else>Happy Customer</span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="container-fluid">-->
<!--                <div class="row">-->
<!--                    <div class="features">-->
<!--                        <div class="block">-->
<!--                            <i class="fas fa-truck-moving fa-2x special"></i>-->

<!--                          <p v-if="lang === 'ar'"><span>شحن مجاني عند الطلب بقيمة 99 ريال أو أكثر</span></p>-->
<!--                          <p v-else>Free Shipping On Order Over SR 99</p>-->
<!--                        </div>-->
<!--                        <div class="block" style="min-width: 210px;">-->
<!--                            <i class="fas fa-phone fa-2x special"></i>-->
<!--                          <p v-if="lang === 'ar'"><span>لدي سؤال؟</span> </p>-->
<!--                          <p v-if="lang === 'ar'"><span>+966 800 789 0000</span> </p>-->
<!--                          <p v-else>Have a Question? +966 800 789 0000</p>-->
<!--                        </div>-->
<!--                        <div class="block" style="min-width: 225px;">-->
<!--                            <i class="fas fa-dollar-sign fa-2x special"></i>-->
<!--                          <p v-if="lang === 'ar'"><span>ضمان استعادة الاموال</span> </p>-->
<!--                          <p v-if="lang === 'ar'"><span>100%</span> </p>-->
<!--                          <p v-else>100% money back Guarantee</p>-->
<!--                        </div>-->
<!--                        <div class="block">-->
<!--                            <i class="fas fa-briefcase fa-2x special"></i>-->
<!--                          <p v-if="lang === 'ar'"><span>إستبدل أو إسترجع خلال 30 يوماً</span> </p>-->
<!--                          <p v-else>30 Days Return Service</p>-->
<!--                        </div>-->
<!--                        <div class="block" style="background-color:#efefef">-->
<!--                          <a v-if="lang === 'ar'" href="#ios"> <i class="fab fa-apple"></i> تحميل </a>-->
<!--                          <a v-else href="#ios"> <i class="fab fa-apple"></i> Download </a>-->
<!--                          <a v-if="lang === 'ar'" href="#android"> <i class="fab fa-android"></i> تحميل </a>-->
<!--                          <a v-else href="#android"> <i class="fab fa-android"></i> Download </a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </section>-->

    </div>
</template>
<script>
    import {mixin} from '@/mixins/mixins';
    import carousel from 'vue-owl-carousel'

    export default {
        components: { carousel },
        mixins: [mixin],
        data () {
            return {
                // componentKey: 0,
            }
        },

        computed: {
            auth () {
                return this.$store.getters['auth/isAuthenticated']
            },
            balance () {
                return this.$store.getters['account/getBalance']
            },
            countryMain(){
                return this.$store.getters['environment/getCountryMain']
            },
        },

        mounted(){
            //
        },

        methods: {
            onLogout() {
                this.$store.dispatch('auth/logout')
            },
        }
    }
</script>
<style>
    /*@import url("https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css");*/
</style>


// WEBPACK FOOTER //
// src/components/website/homepage.vue